import '../style/option-list-Bm9ZAzkz.css'
import { defineComponent as w, toRef as V, computed as l, useModel as E, openBlock as n, createElementBlock as r, normalizeClass as d, normalizeStyle as O, Fragment as g, renderList as R, withDirectives as $, withKeys as N, withModifiers as L, renderSlot as T, createElementVNode as D, toDisplayString as j, unref as i, createBlock as F, createCommentVNode as K } from "vue";
import { isNil as P } from "lodash-es";
import M from "./directives/ripple.js";
import A from "./icon.js";
import { getSpacingVariableByValue as G } from "./utils/style.js";
import { DEFAULT_RIPPLE_SETTING as U } from "./constant/ripple.js";
import { OPTION_LIST_ICON_SIZE as Z } from "./constant/option-list.js";
import { useBreakpoint as q } from "./hooks/useBreakpoint.js";
import { useFormItem as H } from "./hooks/useFormItem.js";
import { useInputSize as J } from "./hooks/useInputSize.js";
const Q = ["onClick", "onKeydown"], W = ["title"], ae = /* @__PURE__ */ w({
  name: "e-option-list",
  __name: "option-list",
  props: {
    modelValue: {},
    withCheckIcon: { type: Boolean },
    items: { default: () => [
      { value: 0.25, text: "25%" },
      { value: 0.5, text: "50%" },
      { value: 0.75, text: "75%" },
      { value: 1, text: "100%" }
    ] },
    full: { type: Boolean },
    compact: { type: Boolean },
    continuous: { type: Boolean },
    space: {},
    borderRadius: { default: "sm" },
    variant: { default: "outline" },
    size: {},
    ripple: { type: [Boolean, Object] },
    columnCount: {},
    textEllipsis: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["selectOption", "update:modelValue"],
  setup(m, { emit: f }) {
    const e = m, v = f, { formSize: b } = H(), { actualSize: a, isSmallSize: y, isDefaultSize: h } = J({ formSize: b, propSize: V(e, "size") }), u = l(() => e.items.map((t) => typeof t == "string" || typeof t == "number" ? {
      value: t,
      text: t
    } : t)), _ = l(() => u.value.find((t) => t.value === e.modelValue)), c = E(e, "modelValue", { local: !0 }), C = l(() => e.ripple ? e.ripple : e.variant === "outline" ? U : !0), k = l(() => {
      const t = [
        "e-option-list",
        {
          "e-option-list--full": e.full,
          "e-option-list--compact": e.compact,
          "e-option-list--continuous": e.continuous,
          "e-option-list--with-check-icon": e.withCheckIcon,
          "e-option-list--text-ellipsis": e.textEllipsis
        }
      ];
      return e.variant && e.variant !== "outline" && t.push(`e-option-list--${e.variant}`), h.value || t.push(`e-option-list--${a.value}`), t;
    }), S = l(() => {
      let t = P(e.space) ? 8 : e.space;
      return (e.compact || e.continuous) && (t = 0), G(t);
    }), x = l(() => e.borderRadius ? `var(--border-radius-${e.borderRadius})` : y.value ? "var(--border-radius-xs)" : "var(--border-radius-sm)"), { breakpoint: z } = q(), B = l(() => {
      let t = e.items.length;
      if (e.columnCount)
        if (typeof e.columnCount == "object") {
          const s = Object.keys(e.columnCount);
          t = e.columnCount[z.value] || e.columnCount[s[s.length - 1]];
        } else
          t = e.columnCount;
      return {
        "--option-list-border-radius": x.value,
        "--option-list-space": S.value,
        "--option-list-count": t
      };
    });
    function p(t) {
      e.disabled || t.disabled || (c.value = t.value, v("selectOption", t.value));
    }
    return (t, s) => (n(), r("div", {
      class: d(k.value),
      style: O(B.value)
    }, [
      (n(!0), r(g, null, R(u.value, (o) => $((n(), r("div", {
        key: o.text,
        role: "button",
        tabindex: "0",
        class: d(["e-option-list__item", { active: o.value === _.value?.value, disabled: t.disabled || o.disabled }]),
        onClick: (I) => p(o),
        onKeydown: N(L((I) => p(o), ["stop", "prevent"]), ["space", "enter"])
      }, [
        T(t.$slots, "item", { item: o }, () => [
          D("span", {
            class: "e-option-list__text",
            title: o.text
          }, j(o.text), 9, W)
        ]),
        t.withCheckIcon && o.value === i(c) ? (n(), F(i(A), {
          key: 0,
          class: "e-option-list__icon",
          icon: "check-circle-fill",
          size: i(Z)[i(a)]
        }, null, 8, ["size"])) : K("", !0)
      ], 42, Q)), [
        [i(M), !t.disabled && !o.disabled && C.value]
      ])), 128))
    ], 6));
  }
});
export {
  ae as default
};
//# sourceMappingURL=option-list.js.map
